module.exports = "/packs/media/images/grading-03fb7fd420b5be6b837653f0d85196a5.png";